import { useState } from "react";
import {
  TransferCategory,
  TransferCreate,
  TransferService,
} from "@/domains/transfer";
import { useAppDispatch, useAppSelector } from "@/stores";
import { tenantSelfWithdrawSelects, tenantSelfWithdrawThunks } from "./store";
// components
import { Button, Form, Input, Modal } from "antd";
import { PlusCircleTwoTone } from "@ant-design/icons";

export const CreateModal = () => {
  const dispatch = useAppDispatch();

  const queryParams = useAppSelector(tenantSelfWithdrawSelects.queryParams);

  const [form] = Form.useForm<TransferCreate>();

  const [isOpen, setIsOpen] = useState(false);

  const handleShow = () => {
    setIsOpen(true);
    form.resetFields();
  };

  const handleConfirm = async () => {
    const formValue = await form.validateFields();

    const data = {
      ...formValue,
      currency: "USDT",
      category: TransferCategory.TenantWithdraw,
    };

    try {
      await TransferService.create(data).run();
      void dispatch(tenantSelfWithdrawThunks.list(queryParams));
    } catch (e) {
      console.log(e);
    }

    setIsOpen(false);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Button type="primary" icon={<PlusCircleTwoTone />} onClick={handleShow}>
        申請下發
      </Button>

      <Modal
        title="申請下發"
        open={isOpen}
        footer={[
          <div className="flex jc:end gap:8" key="footer">
            <Button key="back" onClick={handleCancel}>
              取消
            </Button>
            <Button key="submit" type="primary" onClick={handleConfirm}>
              送出
            </Button>
          </div>,
        ]}
        onCancel={handleCancel}
      >
        <Form className="mt:16" form={form} labelCol={{ span: 6 }}>
          <Form.Item
            label="下發金額"
            name="amount"
            rules={[{ required: true, message: "下發金額不可空白" }]}
          >
            <Input type="number" placeholder="請輸入下發金額" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
